import React, { useEffect } from "react";
import Modal from "antd/lib/modal";
import { Risk } from "./risk";
import './risks.scss';
import { UseRisksContext } from "./useRisks";
import { Details } from "./details";
import { useriskFactorDetailsStore } from "@stores/riskFactorDetailsStore";
import { Spin } from "antd";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../../constants/constants";

export const Risks = function () {
  const {
    patientID,
    loading,
    risks,
    expanded,
    detailsProps,
    showDetails,
    closeDetails
  } = UseRisksContext()

  const [clearStore] = useriskFactorDetailsStore(state => [state.clearStore])

  useEffect(
    () => {
      clearStore()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [patientID]
  )

  return (
    loading ? <Spin spinning={loading}  indicator={<HealthemSpinner/>}></Spin> : (risks.length === 0) ? <DataNotFound message={NO_DATA_FOUND} /> :
    <div className="ui-risks">
      {
        risks.map(
          (risk, index) => <Risk key={index} risk={risk} expanded={expanded} />
        )
      }
      <Modal
        onCancel={() => closeDetails && closeDetails()}
        wrapClassName="ui-factor-details-modal"
        visible={showDetails}
        width="80%"
        centered
        destroyOnClose
      >
        <div className="ui-factor-details-modal__main">
          {
            detailsProps &&
              <Details {...detailsProps} />
          }
        </div>
      </Modal>
    </div>
  )
};
